import { useMemo } from 'react';
import { useEditor } from '@craftjs/core';
import { calcNetNodeSize } from '@common/helpers/domManipulationHelpers';

const useParentSize = () => {
  const { query } = useEditor();

  const parentNetSize = useMemo(() => {
    const { width, height } = calcNetNodeSize(query);

    return { width: Math.floor(width), height: Math.floor(height) };
  }, []);

  return parentNetSize;
};

export default useParentSize;
